import moment from "moment";
import { FiEye, FiClock, FiCheckCircle, FiXCircle, FiPlayCircle, FiAlertCircle } from "react-icons/fi";
import { Table, Button } from "reactstrap";
import NotFoundDataUI from "../cards/NotFoundDataUI";

const DnhJobsTable = ({ data, viewDetails }) => {
    return (
        <div className="modern-table-container">
            <Table responsive className="modern-table mb-0">
                <thead>
                    <tr>
                        <th className="text-center"># ID</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Type</th>
                        <th className="text-center">Manufacturer</th>
                        <th className="text-center">Created At</th>
                        <th className="text-center">Completed At</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((job, index) => (
                            <tr key={index}>
                                <td className="text-center text-muted small fw-bold">
                                    {job.jobId || job.id || index + 1}
                                </td>
                                <td className="text-center">
                                    <span
                                        className={`user-badge d-inline-flex align-items-center gap-1 ${
                                            job.status?.toLowerCase() === "completed"
                                                ? "bg-success-soft text-success"
                                                : job.status?.toLowerCase() === "failed" || job.status?.toLowerCase().includes("error")
                                                ? "bg-danger-soft text-danger"
                                                : job.status?.toLowerCase() === "running"
                                                ? "bg-primary-soft text-primary"
                                                : "bg-secondary-soft text-muted"
                                        }`}
                                    >
                                        {job.status?.toLowerCase() === "completed" && <FiCheckCircle size={12} />}
                                        {job.status?.toLowerCase() === "failed" && <FiXCircle size={12} />}
                                        {job.status?.toLowerCase().includes("error") && <FiAlertCircle size={12} />}
                                        {job.status?.toLowerCase() === "running" && <FiPlayCircle size={12} />}
                                        <span className="text-capitalize">{job.status}</span>
                                    </span>
                                </td>
                                <td className="text-center">
                                    <span className="user-badge bg-primary-soft">
                                        {job.type?.replace(/_/g, ' ')}
                                    </span>
                                </td>
                                <td className="text-center fw-500">
                                    {job.type === "product_import"
                                        ? (job.manufacturer || <span className="opacity-50">—</span>)
                                        : <span className="opacity-50">—</span>}
                                </td>
                                <td className="text-center small text-muted">
                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                        <FiClock size={12} />
                                        {job.timestamps?.createdAt
                                            ? moment(job.timestamps.createdAt).format("MM/DD/YYYY HH:mm")
                                            : job.createdAt
                                                ? moment(job.createdAt).format("MM/DD/YYYY HH:mm")
                                                : "-"}
                                    </div>
                                </td>
                                <td className="text-center small text-muted">
                                    {job.timestamps?.completedAt || job.completedAt ? (
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <FiClock size={12} />
                                            {job.timestamps?.completedAt
                                                ? moment(job.timestamps.completedAt).format("MM/DD/YYYY HH:mm")
                                                : moment(job.completedAt).format("MM/DD/YYYY HH:mm")}
                                        </div>
                                    ) : (
                                        <span className="opacity-50">—</span>
                                    )}
                                </td>
                                <td>
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <Button
                                            className="btn-action bg-white text-info border shadow-sm"
                                            onClick={() => viewDetails(job)}
                                            title="View Details"
                                        >
                                            <FiEye size={16} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7">
                                <NotFoundDataUI message="No DNH jobs found" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default DnhJobsTable;
